/** @jsx jsx */
import { jsx } from '@theme-ui/core';
import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { ModalContainer } from './modal-container';
import { ModalBackdrop } from './modal-backdrop';
import { ModalHeader } from './modal-header';
import { ModalBody } from './modal-body';
import { ModalFooter } from './modal-footer';
import { MODAL_WIDTH_SIZES } from './utils/constants';
var STYLE_ELEMENT_ID = 'uberallModalComponentStyle';
var Modal = function Modal(_ref) {
  var usePortal = _ref.usePortal,
    children = _ref.children,
    footer = _ref.footer,
    width = _ref.width,
    iconHeader = _ref.iconHeader,
    showHeader = _ref.showHeader,
    title = _ref.title,
    onClose = _ref.onClose,
    className = _ref.className,
    enableBackgroundScrolling = _ref.enableBackgroundScrolling;
  var addStylesToPreventScrollingInBackground = function addStylesToPreventScrollingInBackground() {
    var style = document.createElement('style');
    style.id = STYLE_ELEMENT_ID;
    style.innerHTML = 'body { overflow: hidden !important; }';
    document.head.appendChild(style);
  };
  var removeStylesToPreventScrollingInBackground = function removeStylesToPreventScrollingInBackground() {
    var _document$getElementB;
    (_document$getElementB = document.getElementById(STYLE_ELEMENT_ID)) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.remove();
  };
  useEffect(function () {
    if (!enableBackgroundScrolling) {
      addStylesToPreventScrollingInBackground();
    }
    return function () {
      return removeStylesToPreventScrollingInBackground();
    };
  }, [enableBackgroundScrolling]);
  var modal = jsx(ModalBackdrop, {
    onClick: onClose
  }, jsx(ModalContainer, {
    width: width,
    className: className
  }, showHeader && jsx(ModalHeader, {
    onClose: onClose,
    icon: iconHeader,
    title: title
  }), jsx(ModalBody, null, children), footer && jsx(ModalFooter, null, footer)));
  if (!usePortal) {
    return modal;
  }
  return /*#__PURE__*/createPortal(modal, document.body);
};
Modal.defaultProps = {
  usePortal: true,
  width: MODAL_WIDTH_SIZES.LARGE,
  showHeader: true,
  enableBackgroundScrolling: false
};
export { Modal };